var styles = {"login-link":"styles_login-link__3DiXW","loginLink":"styles_login-link__3DiXW"};

export default styles;
//# sourceMappingURL=styles.css.js.map
